import { useFetch } from '@/utils/apiUtils';

/**
 * 2024.10.07 - ljs
 * 운전모니터링>로그정보
 */
const logInfoApi = {
	/**
	 * 실내기 설정 온도 (목록조회)
	 * @param {*} param
	 * @returns
	 */
	getIduSettingLogList: async (param) => {
		return await useFetch('/api/v1/idu-setting-log/getList', param);
	},

	/**
	 * 실내기 설정 온도 (단건조회)
	 * @param {*} param
	 * @returns
	 */
	getIduSettingLogData: async (param) => {
		return await useFetch('/api/v1/idu-setting-log/getData', param);
	},

	/**
	 * 실내기 상태정보로그 (목록조회)
	 * @param {*} param
	 * @returns
	 */
	getIduStatusLogList: async (param) => {
		return await useFetch('/api/v1/idu-status-log/getList', param);
	},

	/**
	 * 실내기 상태정보로그 (단건조회)
	 * @param {*} param
	 * @returns
	 */
	getIduStatusLogData: async (param) => {
		return await useFetch('/api/v1/idu-status-log/getData', param);
	},

	/**
	 * 실외기 운전정보로그 (목록조회)
	 * @param {*} param
	 * @returns
	 */
	getOduRunInfoLogList: async (param) => {
		return await useFetch('/api/v1/odu-run-info-log/getList', param);
	},

	/**
	 * 실외기 운전정보로그 (단건조회)
	 * @param {*} param
	 * @returns
	 */
	getOduRunInfoLogData: async (param) => {
		return await useFetch('/api/v1/odu-run-info-log/getData', param);
	},

	/**
	 * 실외기 상태로그 (목록조회)
	 * @param {*} param
	 * @returns
	 */
	getOduStatusLogList: async (param) => {
		return await useFetch('/api/v1/odu-status-log/getList', param);
	},

	/**
	 * 실외기 상태로그 (단건조회)
	 * @param {*} param
	 * @returns
	 */
	getOduStatusLogData: async (param) => {
		return await useFetch('/api/v1/odu-status-log/getData', param);
	},

	/**
	 * 실외기 상태로그2 (목록조회)
	 * @param {*} param
	 * @returns
	 */
	getOduStatus2LogList: async (param) => {
		return await useFetch('/api/v1/odu-status2-log/getList', param);
	},

	/**
	 * 실외기 상태로그2 (단건조회)
	 * @param {*} param
	 * @returns
	 */
	getOduStatus2LogData: async (param) => {
		return await useFetch('/api/v1/odu-status2-log/getData', param);
	},

	/**
	 * 제품로그 (목록조회)
	 * @param {*} param
	 * @returns
	 */
	getProductLogList: async (param) => {
		return await useFetch('/api/v1/product-log/getList', param);
	},

	/**
	 * 제품로그 (단건조회)
	 * @param {*} param
	 * @returns
	 */
	getProductLogData: async (param) => {
		return await useFetch('/api/v1/product-log/getData', param);
	},

	/**
	 * 제품버전 정보로그 (목록조회)
	 * @param {*} param
	 * @returns
	 */
	getProductVersionLogList: async (param) => {
		return await useFetch('/api/v1/product-version-log/getList', param);
	},

	/**
	 * 제품버전 정보로그 (단건조회)
	 * @param {*} param
	 * @returns
	 */
	getProductVersionLogData: async (param) => {
		return await useFetch('/api/v1/product-version-log/getData', param);
	},

	/**
	 * 에어컨 로그 (목록조회, DocumentDB)
	 * @param {*} param { deviceId, startDate, endDate, pageSize, lastCreateAt }
	 * @returns
	 */
	getAirConditionerLogList: async (param) => {
		return await useFetch(
			'/api/v1/drive-monitoring/getAirConditionerLogList',
			param
		);
	},
};

export default logInfoApi;
